import styled, { css } from 'styled-components';
import { BaSeTheme } from '@base/react';

const brkp = BaSeTheme.breakpoints.tablet.maxWidth;

export const CardRightPanel = styled.div`
  overflow-x: auto;
  position: relative;
  background-color: #f0f6fe;
  width: 100%;
  ::-webkit-scrollbar {
    height: 8px;
  }
`;

export const RightInfoMain = styled.div`
  ${({ blue, height, hide }) => css`
    grid-template-columns: 5fr 1fr 1fr;
    display: grid;
    background-color: ${blue ? '#F0F6FE' : '#fff'};
    align-items: center;
    height: ${height};
    transition: ${BaSeTheme.transitions.allPropertiesContinuousSlow};

    @media screen and (max-width: ${brkp}px) {
      background-color: ${blue
        ? BaSeTheme.colors.institucionais.cinzaSebrae97
        : '#fff'};
    }
    ${hide &&
    css`
      display: none;
      width: 0;
      height: 0;
      opacity: 0;
    `}
  `}
`;

export const HeaderInfoMain = styled.div`
  ${({ height }) => css`
    display: grid;
    padding-left: 24px;
    background-color: #fff;
    border-bottom: 1px solid #e0e6eb;
    align-items: center;
    height: ${height};
    min-width: 426px;
    transition: ${BaSeTheme.transitions.allPropertiesContinuousSlow};
  `}
`;

export const RightInfoCell = styled.div`
  ${({ height, blue, noBorder, last }) => css`
    border-bottom: ${noBorder ? 'none' : '1px solid #e0e6eb'};
    background-color: ${blue ? '#F0F6FE' : '#fff'};
    height: ${height};
    display: grid;
    box-sizing: border-box;
    width: 100%;
    min-width: 150px;
    @media screen and (max-width: ${brkp}px) {
      background-color: ${blue
        ? BaSeTheme.colors.institucionais.cinzaSebrae97
        : '#fff'};
    }
    ${last &&
    css`
      padding-top: 4px;
    `}
  `}
`;

export const RightCellContent = styled.div`
  width: 100%;
  min-width: 150px;
  display: flex;
  align-items: center;
  justify-content: ${({ justify }) => justify ?? 'start'};
  ${({ justify }) =>
    justify &&
    css`
      small {
        padding: 0 10px;
      }
    `}
`;

export const CellCategoriaContent = styled.div`
  width: 100%;
  min-width: 150px;
  display: flex;
  align-items: center;
  padding-left: 24px;
  justify-content: ${({ justify }) => justify ?? 'start'};
  ${({ justify }) =>
    justify &&
    css`
      small {
        padding: 0px 10px;
      }
    `}
`;

export const InfoMainAccordion = styled.div`
  ${({ blue, last, height, hasClick, hide }) => css`
    background-color: ${blue ? '#F0F6FE' : '#fff'};
    border-bottom: 1px solid #e0e6eb;
    height: ${height};
    display: flex;
    align-items: center;
    gap: 10px;
    box-sizing: border-box;
    transition: ${BaSeTheme.transitions.allPropertiesContinuousSlow};
    position: relative;
    ${last &&
    css`
      border-bottom: none;
      border-bottom-left-radius: 8px;
    `}
    ${hasClick &&
    css`
      cursor: pointer;
    `}
    ${hide &&
    css`
      display: none;
      width: 0;
      height: 0;
      opacity: 0;
    `}
    @media screen and (max-width: ${brkp}px) {
      background-color: ${blue
        ? BaSeTheme.colors.institucionais.cinzaSebrae97
        : '#fff'};
    }

    small {
      white-space: nowrap;
    }
  `}
`;

export const HeaderEmpty = styled.div`
  height: 43px;
  border-bottom: 1px solid #e0e6eb;
`;
